var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlackTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.136 0 0 3.136 0 7C0 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 7 0ZM6.3 3.5V4.9H7.7V3.5H6.3ZM6.3 6.3V10.5H7.7V6.3H6.3ZM1.4 7C1.4 10.087 3.913 12.6 7 12.6C10.087 12.6 12.6 10.087 12.6 7C12.6 3.913 10.087 1.4 7 1.4C3.913 1.4 1.4 3.913 1.4 7Z",
    fill: "#2F3245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlackTooltip);
export default __webpack_public_path__ + "static/media/info_black-tooltip.e7dab53227dec7dd49dd6fcd6de4f912.svg";
export { ForwardRef as ReactComponent };